import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
//
import App from './app';
import store from './context/store';
import Maintenance from './pages/maintenance/maintenance';
import { SplashScreen } from './components/loading-screen';

// ----------------------------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

const isMaintenanceMode = false;

if (isMaintenanceMode) {
  window.history.replaceState({}, '', '/maintenance');
}

root.render(
  <HelmetProvider>
    <Provider store={store}>
      <BrowserRouter>
          {isMaintenanceMode ? <Maintenance /> : <App />}
      </BrowserRouter>
    </Provider>
  </HelmetProvider>
);
